import FooterSection from "assets/Footer";
import Navbar from "assets/Navbar";
import check from "../../src/images/check.webp";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ConfirmOrder = () => {
  const location = useLocation();
  const orderData = location.state;
  useEffect(() => {
    if (!orderData) return;
    // OrderDetails er API te ekbarpush korle ar ekhane korar dorkar nai
    // window.dataLayer = window.dataLayer || [];

    // window.dataLayer.push({
    //   event: "purchase",
    //   ecommerce: {
    //     transaction_id: orderData.orderId,
    //     value: Number(orderData.totalPrice),
    //     currency: "BDT",
    //     items: orderData.products.map((item) => ({
    //       item_id: item.item_id,
    //       item_name: item.selectedVariant?.title,
    //       price: Number(item.selectedVariant?.flashPrice),
    //       quantity: item.quantity || 1,
    //       item_category: item.catalogue_title,
    //     })),
    //   },
    // });

    // console.log("Purchase fired on confirm page");
  }, []);
  return (
    <div className="flex flex-col min-h-[100dvh] bg-[#F5F5F5]">
      <Navbar />
      <div className="flex-1 flex items-center justify-center">
        <div className="flex flex-col items-center justify-center text-center">
          <img
            src={check}
            alt="Confirm"
            className="w-[100px] md:w-[150px] h-auto "
          />
          <p className="my-5 text-gray-700 text-center md:text-base text-sm">
            💖 আপনার অর্ডারটি কনফার্ম করা হয়েছে, <br />
            খুব শীঘ্রই আমাদের প্রতিনিধি আপনার সাথে যোগাযোগ করবে 💖
          </p>
          <Link
            to="/"
            className="bg-backgroundColor text-white py-2 px-5 rounded md:text-sm text-xs"
          >
            আরো অর্ডার করতে বা পণ্য দেখতে এখানে ক্লিক করুন
          </Link>
        </div>
      </div>
      <FooterSection />
    </div>
  );
};

export default ConfirmOrder;
